import React, { useState } from "react";
import API from "../../api/axios";
import { useNavigate } from "react-router-dom";
import VerifyRegister from "./VerifyRegister";

export default function VerifyLogin() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setError("");
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await API.post("/login", form,
                {  headers: {
                        "Content-Type": "application/json",
                    },


                }      );
            if (res.data.status) {
                localStorage.setItem("user", JSON.stringify(res.data.data?.user));
                localStorage.setItem("token", res.data.data?.token);
                navigate("/verifysuccess");
            } else {
                setError(res.data.message);
            }
        } catch (err) {
            console.error(err);
            setError("Login failed. Please try again.");
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4">
            <img src="logo.png" alt="" srcset="" className="max-w-[200px] w-full mb-6"/>
            <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-[#E3BCF4]">
                <h2 className="text-2xl font-bold text-center mb-6 text-[#652F9B]">Login to my account</h2>
                {error && <div className="text-red-600 text-sm mb-4 text-center">{error}</div>}
                <form onSubmit={handleSubmit} >
                    <div className="space-y-4">
                        {/* <label className="block text-sm font-medium text-gray-700">Email</label> */}
                        <input
                            name="email"
                            type="email"
                            required
                            value={form.email}
                            onChange={handleChange}
                            placeholder="you@example.com"
                            // className="mt-1 block w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"

                        />
                        <input
                            name="password"
                            type="password"
                            required
                            value={form.password}
                            onChange={handleChange}
                            placeholder="••••••••"
                            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
                        />
                        <button
                            type="submit"
                            className="mt-6 w-full bg-[#8E29CD] hover:bg-[#8B1D9A] text-white font-medium py-2 rounded-lg transition duration-200"
                        >
                            Login
                        </button>
                        <a
                            href="/verifyregister"
                            className="mt-6 w-full bg-[#8E29CD] hover:bg-[#8B1D9A] text-white text-center font-medium py-2 rounded-lg transition duration-200 block"
                        >
                            Get Verified
                        </a>

                        {/*<a*/}
                        {/*    href="/verifycancel"*/}
                        {/*    className="mt-6 w-full bg-[#9B20AC] hover:bg-[#8B1D9A] text-white text-center font-medium py-2 rounded-lg transition duration-200 block"*/}
                        {/*>*/}
                        {/*    Cancel*/}
                        {/*</a>*/}


                    </div>
                </form>
                {/*<div className="mt-4 text-sm text-center text-gray-600">*/}
                {/*    Don’t have an account?{" "}*/}
                {/*    <a href="/verifyregister" className="text-[#740d82] hover:underline">Get Verified</a>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}
